import { render } from "./DynamicCourseDetails.vue?vue&type=template&id=7e3154dc"
import script from "./DynamicCourseDetails.vue?vue&type=script&lang=js"
export * from "./DynamicCourseDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__